module.exports = __webpack_public_path__ + "img/MALE.730d6452.svg";